import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import EmailNotificationActionRecipients from 'automation-ui-action-features/actions/email-notification/EmailNotificationActionRecipients';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmailNotificationActionSummary({
  actionMetadata,
  flowObjectTypeId
}) {
  const {
    subject
  } = actionMetadata;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.email-notification.summary",
    options: {
      subject: subject ? /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(PersonalizedTextView, {
          propertyTypeId: flowObjectTypeId,
          text: subject
        })
      }) : /*#__PURE__*/_jsx(MissingLabel, {
        type: "title"
      }),
      recipients: /*#__PURE__*/_jsx(EmailNotificationActionRecipients, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    }
  });
}